import { useRef, useState } from "react";
import { LuChevronDown } from "react-icons/lu";

import Picker from "./Picker";

// A dropdown built on Picker, so every list on the careers pages looks and
// behaves the same instead of falling back to the browser's native select.
// variant: "field" (form input), "compact" (toolbar), "bare" (inside a card).
export default function Select({
  id,
  value,
  options,
  onChange,
  placeholder = "Choose",
  title,
  searchable = false,
  searchPlaceholder,
  filter,
  variant = "field",
  icon,
  invalid = false,
  describedBy,
  labelledBy,
  align,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const current = options.find((o) => o.value === value);

  const close = () => {
    setOpen(false);
    triggerRef.current?.focus();
  };

  const onTriggerKey = (e) => {
    if (["ArrowDown", "ArrowUp"].includes(e.key)) {
      e.preventDefault();
      setOpen(true);
    }
  };

  return (
    <div className={`cr-select-wrap cr-select-wrap--${variant}`}>
      <button
        id={id}
        ref={triggerRef}
        type="button"
        className={`cr-select-trigger cr-select-trigger--${variant}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-invalid={invalid}
        aria-describedby={describedBy}
        aria-labelledby={labelledBy ? `${labelledBy} ${id}` : undefined}
        data-placeholder={!current}
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={onTriggerKey}
      >
        {icon && (
          <span className="cr-select-icon" aria-hidden="true">
            {icon}
          </span>
        )}
        {current?.icon && (
          <span className="cr-picker-icon" aria-hidden="true">
            {current.icon}
          </span>
        )}
        <span className="cr-select-value">{current?.label ?? placeholder}</span>
        <LuChevronDown className="cr-select-chevron" aria-hidden="true" />
      </button>
      {open && (
        <Picker
          title={title}
          options={options}
          value={value}
          searchable={searchable}
          searchPlaceholder={searchPlaceholder}
          filter={filter}
          align={align}
          onClose={close}
          onPick={(v) => {
            onChange(v);
            close();
          }}
        />
      )}
    </div>
  );
}
